import { SUBSCRIPTION } from "../shared/tagTypes";
import { baseApi } from "./base";

const subscriptionApi = baseApi
  .enhanceEndpoints({
    addTagTypes: [SUBSCRIPTION],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getSubscriptions: builder.query({
        query: (payload) => ({
          url: "/subscriptions",
          params: {},
        }),
        providesTags: [SUBSCRIPTION],
      }),
      getSubscription: builder.query({
        query: (payload) => ({
          url: `/subscriptions/${payload.id}`
        }),
        providesTags: [SUBSCRIPTION],
      }),
      createSubscription: builder.mutation({
        query: (payload) => ({
          url: "/subscriptions",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: [SUBSCRIPTION],
      }),
      updateSubscription: builder.mutation({
        query: (payload) => ({
          url: `/subscriptions/${payload.id}`,
          method: "PUT",
          body: payload.body,
        }),
        invalidatesTags: [SUBSCRIPTION],
      }),
      deleteSubscription: builder.mutation({
        query: (payload) => ({
          url: `/subscriptions/${payload.id}`,
          method: "DELETE",
        }),
        invalidatesTags: [SUBSCRIPTION],
      })
    }),

    overrideExisting: false,
  });

export const {
  useGetSubscriptionsQuery,
  useLazyGetSubscriptionsQuery,
  useGetSubscriptionQuery,
  useLazyGetSubscriptionQuery,
  useCreateSubscriptionMutation,
  useUpdateSubscriptionMutation,
  useDeleteSubscriptionMutation
} = subscriptionApi;
